import { connect } from 'react-redux';
import { setModalOpen, setModalClosed, setModalStandaloneClosed } from 'actions/modal-actions';
import Modal from './Modal';

const mapDispatchToProps = {
  onSetModalOpen: setModalOpen,
  onSetModalClosed: setModalClosed,
  onSetModalStandaloneClosed: setModalStandaloneClosed,
};

export default connect(null, mapDispatchToProps)(Modal);
